import React, {useState, useContext, useCallback} from 'react';
import { debounce } from 'lodash';

import { ReactComponent as IconVisibility } from '../../../../assets/icons/visibility.svg';
import { ReactComponent as IconNotVisibility } from '../../../../assets/icons/not_visibility.svg';

import { ReactComponent as IconVisibilityLight } from '../../../../assets/icons/visibility_light.svg';
import { ReactComponent as IconNotVisibilityLigh } from '../../../../assets/icons/not_visibility_light.svg';

import { ReactComponent as Lock } from '../../../../assets/icons/lockGreen.svg';
import { ReactComponent as Mail } from '../../../../assets/icons/mailGreen.svg';
import { ReactComponent as User } from '../../../../assets/icons/perfilGreen.svg';
import ThemeContext from '../../../../context/theme';
import {Container} from './styles';


const Input = ({
        type,
        icon,
        name,
        placeholder,
        value,
        onChange,
        onBlur,
        messageError,
        isError,
        className,
        classNameCustom
          }) => {

  const [visibilityPassword, setVisibilityPassword] = useState(false);
  const [errorDebounce, setErrorDebounce] = useState(false);
  const {themeSelect} = useContext(ThemeContext);

  const onChangeDebounc = useCallback(debounce((messageError) => {
       setErrorDebounce(false);
       if(!!messageError){
        return setErrorDebounce(true);
      }
      setErrorDebounce(false);
     }, 1000),[debounce, errorDebounce]);

  const handleChange = (event) => {
    onChange(event)
    onChangeDebounc(messageError);
  }

  return (
    <Container 
      errorProps={(isError || (errorDebounce && !!messageError))} 
      themeSelect={themeSelect.title} 
      className={'input-custom ' + (classNameCustom ?? '')}>
      {icon === 'mail' 
        ? <Mail /> 
        : icon === 'user' 
          ? <User /> 
          : icon === 'null'
            ? null
            :<Lock />}
      <div>
        { (isError || (errorDebounce && !!messageError)) && <small>{messageError}</small> }
        <input
         value={value}
         onChange={handleChange}
         name={name}
         onBlur={onBlur}
         className={'col ' + (className ?? '')}
         placeholder={placeholder}
         type={type === 'password' ?
         visibilityPassword ? 'text' : 'password' :
         type
         }

         />
       </div>
    </Container>
  );
};

export default Input;
